import { createSlice } from '@reduxjs/toolkit';
import {
  getAllCustomFail,
  getAllCustomPending,
  getAllCustomSuccess,
  INITIAL_STATE_CUSTOM,
  resetResourceDataCustom,
} from 'redux/crudCreatorCustom/utils';
import { getUnownedProvidersOfUser } from './actions';

export const initialState = {
  ...INITIAL_STATE_CUSTOM,
};

const { actions, reducer } = createSlice({
  name: 'UnownedProvidersOfUser',
  initialState,
  reducers: {
    resetResourceFilterProvidersOfProviders: resetResourceDataCustom,
  },
  extraReducers: {
    [getUnownedProvidersOfUser.pending]: getAllCustomPending,
    [getUnownedProvidersOfUser.fulfilled]: getAllCustomSuccess,
    [getUnownedProvidersOfUser.rejected]: getAllCustomFail,
  },
});

export const { resetResourceFilterUnownedProvidersOfUser } = actions;

export default reducer;
